import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import clsx from 'clsx';
import * as bibHorStyles from '../../../styles/custom/bib-horaire.module.scss';
import * as styleLink from '../../../styles/communs/polylink.module.scss';
import {useTranslation} from 'react-i18next';
import PolyLink from '../PolyLink';

const BibHoraire = ({elem, column, row}) => {
  const config = elem.config;
  const {t} = useTranslation();
  const [library, setLibrary] = React.useState(null);
  const [today, setToday] = React.useState(null);
  const [tomorrow, settomorrow] = React.useState(null);

  const getRefDate = (dte) => {
    const tdd = dte.toLocaleDateString('fr-FR').split('/');
    return `${tdd[2]}-${tdd[1]}-${tdd[0]}`;
  };

  const tdate = new Date();
  const refToday = getRefDate(tdate);
  tdate.setDate(tdate.getDate() + 1);
  const refTomoorow = getRefDate(tdate);

  React.useEffect (() => {
    const getLibcalHours = async () => {
      try {
        let st = 1;
        if (config.systemTime === 0 ) {
          st = 0;
        }
        return await axios.get('https://sciencespo.libcal.com/widget/hours/grid', {
          params : {
            lid : config.lid,
            format : 'json',
            weeks: 2,
            systemTime: st
          }
        });
      } catch (error) {
        console.error ('libcal server not available');
      }
    };
    const getData = async () => {
      const resp = await getLibcalHours();
      if (!resp || resp.status !== 200 || !resp.data) {
        return;
      }
      const dta = resp.data[`loc_${config.lid}`];
      if (!dta) {
        return;
      }
      if (!config.entity) {
        setLibrary(dta.name);
      }
      dta.weeks.forEach(el => {
        Object.entries(el).forEach(([, details]) => {
          if (details.date === refToday) {
            setToday (details.rendered);
          }
          if (details.date === refTomoorow) {
            settomorrow (details.rendered);
          }
        });
      });
    };
    if (config?.entity) {
      setLibrary(config.entity);
    }
    if (config?.lid) {
      getData();
    }
  }, [config.lid, config.systemTime, config.entity]);


  return (
    <PolyLink
      ariaLabel={library}
      className={clsx(bibHorStyles.root, {[bibHorStyles.link]: config.url})}
      target={config?.newTab ? '_blank': '_self'}
      url={config?.url}
    >
      <div
        style={{
          paddingBottom: `calc((100% / ${column}) * (${row}))`,
          gridArea: '1 / 1 / -1 / -1'
        }}
      />
      <div className={bibHorStyles.container}>
        {(!library) ?
          <div className={clsx(bibHorStyles.wait, bibHorStyles.titleWait)}/>
          :
          <h3
            className={bibHorStyles.title}
          >
            {library}
          </h3>
        }
        <div>
          <p className={bibHorStyles.line}>
            {t('widget.custom.bib_horaire.today')}:
            {((!today) ?
              <span className={clsx(bibHorStyles.wait, bibHorStyles.hour)}/>
              :
              <span className={bibHorStyles.hourSpan}>{' '+ today}</span>
            )}
          </p>
          <p className={clsx(bibHorStyles.line, styleLink.withoutIcon)}>
            {t('widget.custom.bib_horaire.tomorrow')}:
            {((!tomorrow) ?
              <span className={clsx(bibHorStyles.wait, bibHorStyles.hour)}/>
              :
              <span className={bibHorStyles.hourSpan}>{' '+ tomorrow}</span>
            )}
          </p>
        </div>
      </div>
    </PolyLink>
  );
};


BibHoraire.propTypes = {
  column: PropTypes.number,
  elem : PropTypes.object.isRequired,
  row: PropTypes.number
};

export default BibHoraire;